<template>
  <div class='main'>
    <div class='detail-main'>
      <div class='title'>
        <div class='detail-icon'><span class='iconfont icon-money'></span></div>
        <template v-if="entoType">
          <div v-if="dataInfo.OptAmountBack >= 0" class="detail-text">待返金额增加-特卖购买完成</div>
          <div v-else class="detail-text">{{ dataInfo.BackType | lessThanZeroTextFilter }}</div>
        </template>
        <template v-else>
          <div class="detail-text">{{dataInfo.OptContent || '----'}}</div>
        </template>
      </div>
      <div class='price' v-if="entoType">{{dataInfo.OptAmountBack | formatMoneyStutas}}</div>
      <div class='price' v-else>{{dataInfo.OptMoney | formatMoneyStutas}}</div>
      <div class='txt'>交易成功</div>
      <div class='detail-item'>
        <span>创建时间</span>
        <span>{{dataInfo.CreateTime | fromatTime}}</span>
      </div>
      <div class='detail-item' v-if="dataInfo.PlatformOrderID">
        <span>订单编号</span>
        <span>{{dataInfo.PlatformOrderID}}</span>
      </div>
      <div class='detail-item' v-if="!entoType && dataInfo.TradeID">
        <span>交易编号</span>
        <span>{{dataInfo.TradeID}}</span>
      </div>
    </div>
    <div class='btn'>
      <mt-button type="danger" @click.native="goBack">返回</mt-button>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import numeral from 'numeral'
import moment from 'moment'
import {
  SAppAmountInfoGet,
  SaleAmounBackInfoGet
} from '@/api/my'

export default {
  data () {
    return {
      entoType: 0,
      id: '',
      dataInfo: {}
    }
  },
  mounted () {
    this.entoType = this.$route.query.type ? parseInt(this.$route.query.type) : 0
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.fetchData()
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      if (this.entoType) {
        SaleAmounBackInfoGet({ ID: this.id }).then(res => {
          Indicator.close()
          this.dataInfo = res.SaleAmountBackInfo
        }).catch(err => {
          Indicator.close()
          Toast(err.ErrMsg)
        })
      } else {
        SAppAmountInfoGet({ ID: this.id }).then(res => {
          Indicator.close()
          this.dataInfo = res.SAppAmountInfo
        }).catch(err => {
          Indicator.close()
          Toast(err.ErrMsg)
        })
      }
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  filters: {
    formatMoneyStutas (value) {
      if (value) {
        return numeral(value).format('0,0.00')
      } else {
        return '----'
      }
    },
    fromatTime (val) {
      if (val) {
        return moment(val).format('YYYY-MM-DD')
      } else {
        return '----'
      }
    },
    lessThanZeroTextFilter (BackType) {
      let tempStr = '' 
      // BackType 试用返还 = 0, 特卖返还 = 1, 订单退款 = 2
      switch (BackType) {
        case 1:
          tempStr = '待返金额减少-成功返款'
          break;
        case 2:
          tempStr = '待返金额减少-订单已退款'
          break;
        case 3:
          tempStr = '特卖金额减少-扣减首单礼金或其他优惠'
          break;
      }
      return tempStr
    }
  }
}
</script>

<style scoped>
  .main{
    font-size: 13px;
    background: #f5f5f5;
    min-height: 100vh;
    overflow: hidden;
  }
  .detail-main{
    padding: 4%;
    background: #fff;
  }
  .detail-main .title{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    line-height: 2.5em;
    font-size: 14px;
  }
  .detail-main .detail-icon{
    width: 2.5em;
    height: 2.5em;
    line-height: 2.5em;
    background: #f48f54;
    border-radius: 50%;
    text-align: center;
    margin-right: 3%;
    flex-shrink: 0;
  }
  .detail-main .detail-text{
    overflow: hidden;
  }
  .detail-icon span{
    font-size: 18px;
    color: #fff;
  }
  .detail-main .price{
    text-align: center;
    font-size: 2em;
    font-weight: 700;
    margin: 2% 0;
  }
  .detail-main .txt{
    text-align: center;
    color: #999;
    height: 1.8em;
    line-height: 1.8em;
    padding-bottom: 3%;
    margin-bottom: 3%;
    border-bottom: 1px solid #eee;
  }
  .detail-main .detail-item{
    display: flex;
    justify-content: space-between;
    color: #999;
    height: 2.5em;
    line-height: 2.5em;
  }
  .btn{
    width: 90%;
    margin:  0 auto;
    margin-top: 3.8em;
    text-align: center;
  }
  .btn button {
    width: 100%;
    letter-spacing: 10px;
  }
</style>
